import "./MoldTesting.module.css";
import Header from "@/reusable_sections/Header";
import SellYourMotorcycleFastAndSafe from "./sections/SellYourMotorcycleFastAndSafe";
import ThreeStepProcess from "./sections/ThreeStepProcess";
import Kwaliteitsgarantie from "./sections/Kwaliteitsgarantie";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function MoldTestingPage() {
  return <div>
      <Header />
      <SellYourMotorcycleFastAndSafe />
      <ThreeStepProcess />
      <Kwaliteitsgarantie />
      <CallToAction />
      <Footer />
    </div>;
}